import styled from 'styled-components';

const Container = styled.button`
  width: 100%;
  height: 92px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #e2dffd;
  }
  &:focus {
    background-color: #c6c0fc;
  }
  &:active {
    background-color: #c6c0fc;
  }

  > div {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    img {
      width: 32px;
      height: 32px;
    }

    h3 {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #161d1f;
    }
  }

  > p {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #4f6168;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default Container;
